import {Grid, IconButton, styled, Typography} from "@mui/material"
import {Document, Page, pdfjs} from "react-pdf"
import {DownloadIcon} from "lucide-react"
import React, {useCallback} from "react"
import {fileServerUrlParser} from "../../misc/utils"
import PropTypes from "prop-types";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString()

const PDFCardWrapper = styled(Grid)(({theme}) => theme.PDFCARD.wrapper)
const ImageBox = styled(Grid)(({theme}) => theme.PDFCARD.imagebox)
const MainText = styled(Typography)(({theme}) => theme.PDFCARD.maintext)
const SubText = styled(Typography)(({theme}) => theme.PDFCARD.subtext)

const PDFCardWidget = ({widget}) => {
    const displayFileName = widget?.url?.split("/")[2]
    const fullFileserverUrl = fileServerUrlParser(widget?.url)

    const onClick = useCallback(() => {
        globalThis.open(fullFileserverUrl, "_blank")
        const link = document.createElement("a")
        link.href = fullFileserverUrl
        link.setAttribute("download", displayFileName)
    }, [fullFileserverUrl, displayFileName])

    return (
        <PDFCardWrapper container>
            <Grid container display="flex" alignItems="center" spacing={2}>
                <ImageBox>
                    <Document file={fullFileserverUrl}>
                        <Page pageNumber={1} width={120}/>
                    </Document>
                </ImageBox>
                <Grid display="flex" flexDirection="column">
                    <MainText>{displayFileName}</MainText>
                    <SubText>{widget?.subtitle}</SubText>
                </Grid>
            </Grid>
            <Grid mr="16px">
                <IconButton onClick={onClick}><DownloadIcon color="#000"/></IconButton>
            </Grid>
        </PDFCardWrapper>
    )
}

export default PDFCardWidget

PDFCardWidget.propTypes = {
    widget: PropTypes.shape({
        url: PropTypes.string,
        subtitle: PropTypes.string,
    })
}
